// Public server function that returns the Sentry DSN so the browser can
// initialize Sentry without needing a VITE_-prefixed env var. The DSN is a
// publishable identifier (safe to expose) and is read from SENTRY_DSN.
import { createServerFn } from "@tanstack/react-start";
import { resolveEnvironment } from "./sentry/scrub";

export const getSentryConfig = createServerFn({ method: "GET" }).handler(async () => {
  return {
    dsn: process.env.SENTRY_DSN ?? "",
    environment: resolveEnvironment(),
  };
});
